module.exports = __webpack_public_path__ + "df932ded44d21317f34f717d08b27961.webp";